import { Link } from 'react-router-dom'

const RowClickable = ({ 
	value, endpoint = window.location.pathname.replace('/', ''), value2 = '',
	label = value
}) => {
	return <Link className="text-blue-500 cursor-pointer hover:underline"
		as={Link} to={`/${endpoint}/${value}${value2 ? '/'+value2:''}`}>{label}</Link>
}

export default RowClickable